import { apiClient } from "@/services/HttpService";

export function fetchRoleList() {
  return apiClient.get("/roles");
}

export function saveRole(roleParam) {
  return apiClient.post("/roles", roleParam);
}
export function deleteRole(roleId) {
  return apiClient.delete(`/roles/${roleId}`);
}